<section class="w-full">
    <app-banner_section-type01
        [options]="{
            title: '',
            imageHref: 'assets/images/xl-travel-banners/XL-WEB-PAGE-BANNERS-3.jpg?'
        }"
    ></app-banner_section-type01>
    <div>
        <div class="px-4 py-8">
            <h2 class="text-center font-semibold tracking-wide text-4xl">
                Beyond the ordinary
            </h2>
        </div>
        <div
            class="w-full mx-auto sm:px-6 pb-16 grid md:grid-cols-2 lg:grid-cols-2 gap-y-8 lg:gap-x-8"
        >
            <div class="flex flex-col">
                <div>
                    <p
                        class="font-light px-3 text-gray-500"
                        [innerHTML]="view.page?.content.rawContent"
                    ></p>
                </div>
            </div>
            <div
                class="w-full px-3 space-y-4 md:grid md:grid-cols-2 md:gap-8 md:space-y-0"
            >
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:identification"
                        >
                            <!-- New icon for extensive network -->
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Extensive Network
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        Over 150 leading travel agencies across Southern Africa
                        form the XL Travel Group.
                    </p>
                </div>
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:shopping-cart"
                        >
                            <!-- New icon for powerful buying -->
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Powerful Buying
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        Our annual R6 billion ( USD 332 million ) in sales secures exclusive
                        cost-saving benefits for clients.
                    </p>
                </div>
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:globe-alt"
                        >
                            <!-- New icon for agile solutions -->
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Agile Solutions
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        XL Travel adapts to industry changes, offering flexible
                        and tailored travel options.
                    </p>
                </div>
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:star"
                        >
                            <!-- New icon for entrepreneurial spirit -->
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Entrepreneurial Spirit
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        Independently-owned agencies bring diversity and
                        innovation to our consortium.
                    </p>
                </div>
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:map"
                        >
                            <!-- New icon for comprehensive coverage -->
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Comprehensive Coverage
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        XL offices serve all of South Africa and neighboring
                        countries, ensuring broad access.
                    </p>
                </div>
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:sparkles"
                        >
                            <!-- New icon for specialized services -->
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Specialized Services
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        From eco-friendly getaways to corporate travel, XL
                        agencies meet all travel needs.
                    </p>
                </div>
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:currency-dollar"
                        >
                            <!-- New icon for cost efficiency -->
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Cost Efficiency
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        Our procurement power helps us provide competitive
                        pricing for leisure and business.
                    </p>
                </div>
                <div>
                    <div class="flex">
                        <mat-icon
                            class="icon-size-5 text-primary-500 mr-2"
                            svgIcon="heroicons_outline:squares-2x2"
                        >
                        </mat-icon>
                        <h3 class="mb-2 text-lg font-bold dark:text-white">
                            Exceptional Experiences
                        </h3>
                    </div>
                    <p class="font-light text-gray-500">
                        XL Travel Member Agencies deliver unforgettable travel
                        experiences, beyond the ordinary.
                    </p>
                </div>
            </div>
            <!-- <fuse-card class="flex flex-col w-full mx-auto overflow-hidden shadow-2xl hover:shadow-lg dark:border-0 dark:border-gray-500 dark:bg-gray-600">
                    <div  class=" w-[100%] md:w-[50%] lg:w-[50%]  xl:w-[50%]">
                    <iframe width="100%" height="100%" 
                        src="https://www.youtube.com/watch?v=yaNvvzQNT-8" 
                        title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        allowfullscreen>
                    </iframe>
                </div>
            </fuse-card> -->
        </div>
    </div>
    <!-- <app-scroller_section-type01></app-scroller_section-type01> -->
</section>
